import {colors} from "@c10h/colors";
import Link from "next/link";
import {Trans, useTranslation} from "ni18n";
import React from "react";

import {PHONE_NUMBERS} from "../../../constants/InsurancePricingConstants";
import {analytics} from "../../../utils/analytics";
import {v5Pages} from "../../_common/_constants";
import {formatPhoneNumber} from "../../_common/Carbon";
import {Btn} from "../V5Comp";

const Billing = (): React.ReactElement => {
  const i18n = useTranslation();

  const trackPhoneClick = (phoneNumber: string) => {
    const phoneClickEvent = {
      category: analytics.category.SUPPORT,
      label: analytics.label.CONTACT_SUPPORT,
      action: analytics.action.CLICKED,
      value: phoneNumber,
    };

    analytics.post(phoneClickEvent);
  };

  const modes = [
    {
      icon: "profile-picture",
      color: colors.yellow,
      title: (
        <Trans>
          Pre-Visit
          <br />
          Patient Inquiries
        </Trans>
      ),
      text: i18n.t("Every Day\n9:30 AM to 6:00 PM Pacific"),
      email: "support@carbonhealth.com",
      bottom: (
        <>
          <span className="font-ir gray600 fs12 lh15">{i18n.t("Call your clinic directly")}</span>
          <Link
            href={v5Pages.locations}
            style={{textUnderlineOffset: 2}}
            className="tdu darkBlue font-ib fs12 lh15"
          >
            carbonhealth.com/locations
          </Link>
        </>
      ),
    },
    {
      icon: "hand-phone-cross",
      color: colors.lightBlue,
      title: i18n.t("Patient Billing Questions"),
      text: i18n.t("Monday - Friday\n9:30 AM to 5:00 PM Pacific"),
      email: "billing@carbonhealth.com",
      phoneNumber: PHONE_NUMBERS.MAIN,
    },
    {
      icon: "hands-cross",
      color: colors.lightPurple,
      title: i18n.t("Insurance Companies"),
      text: i18n.t("You can directly contact our insurance and billing representatives."),
      email: "billing@carbonhealth.com",
      phoneNumber: PHONE_NUMBERS.MAIN,
      bottom: "",
    },
  ];

  return (
    <section
      aria-label={i18n.t("Billing Support")}
      className="bg-gray100 df fdc jcc pb46 pb20-md pt28 pt10-md tac contrast-tbt"
    >
      <div className="df aic fdc mb24 mb6-sm">
        <h2 className="ttu fs13 gray400 font-isb ls2 lh18 mb8">{i18n.t("Billing Support")}</h2>
        <strong className="fs40 fs30-sm gray800 tdn font-cm">
          {i18n.t("Still have questions?")}
          <br className="dn db-md" /> {i18n.t("We have answers.")}
        </strong>
      </div>
      <ul className="dg gg6 gtc3fr df-lg fdc maxw70 ma ph4-xl">
        {modes.map(m => (
          <li
            key={m.icon}
            className="ph12 ph4-xl ph8-lg pv20 bg-white br8 mb4-md maxw25 contrast-tb"
          >
            <div className="df fdc aic">
              <div
                aria-hidden
                className={`cIcon-${m.icon} br50 mb3 df jcc aic fs40`}
                style={{height: 68, width: 68, backgroundColor: m.color}}
              />
              <h3 className="fs32 fs28-lg font-c maxw32 lh12 mb5">{m.title}</h3>
              <span className="font-ir fs14 lh14 gray400 mb12 maxw16">{m.text}</span>
              <Btn
                fontSize={0.75}
                className="mb3 gray50-f font-ib-f bg-gray800-f contrast-tb-f"
                href={`mailto:${m.email}`}
              >
                {m.email}
              </Btn>
              {m.phoneNumber && (
                <Btn
                  fontSize={0.75}
                  bg="#fff"
                  className="p3-f brd2nc-f brd-gray800-f"
                  color={colors.gray800}
                  onClick={() => trackPhoneClick(m.phoneNumber)}
                  href={`tel:${m.phoneNumber}`}
                >
                  {formatPhoneNumber(m.phoneNumber)}
                </Btn>
              )}
              {m.bottom && m.bottom}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Billing;
